import { render } from "./CartTable-DiscoverMode.vue?vue&type=template&id=1a7ba231"
import script from "./CartTable-DiscoverMode.vue?vue&type=script&lang=js"
export * from "./CartTable-DiscoverMode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\glenn.degroot\\source\\repos\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__